module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/5mill-inactive-086aa5f5c4721b54e8ec76d8bc024b31.png";